export default __webpack_public_path__ + "static/blob8-f7a3cce4f5a951488ee2224e272c0fa3.svg";